/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI WL
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ChatbotResponseLength = {
    Short: 'Short',
    Medium: 'Medium',
    Long: 'Long'
} as const;
export type ChatbotResponseLength = typeof ChatbotResponseLength[keyof typeof ChatbotResponseLength];


export function instanceOfChatbotResponseLength(value: any): boolean {
    for (const key in ChatbotResponseLength) {
        if (Object.prototype.hasOwnProperty.call(ChatbotResponseLength, key)) {
            if (ChatbotResponseLength[key as keyof typeof ChatbotResponseLength] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ChatbotResponseLengthFromJSON(json: any): ChatbotResponseLength {
    return ChatbotResponseLengthFromJSONTyped(json, false);
}

export function ChatbotResponseLengthFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatbotResponseLength {
    return json as ChatbotResponseLength;
}

export function ChatbotResponseLengthToJSON(value?: ChatbotResponseLength | null): any {
    return value as any;
}

export function ChatbotResponseLengthToJSONTyped(value: any, ignoreDiscriminator: boolean): ChatbotResponseLength {
    return value as ChatbotResponseLength;
}

